import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import download from 'downloadjs';
import Loader from './../shared/loader'
import {
	Validator
} from 'vee-validate'
import Pagination from './../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import JsonExcel from "vue-json-excel";
import Vue from "vue";
Vue.component("downloadExcel", JsonExcel);
import common_helper from '../../../common_helper'
import VueElementLoading from 'vue-element-loading'


export default {
	name: 'product',
	components: {
		//Paginate,
		Pagination,
		Loader,
		DatePicker,
		Loader,
		BasicSelect,
		JsonExcel,
		VueElementLoading
	},
	data: function() {
		return {
			currentPage: 1,
			formattedDate: '',
			totalPage: 0,
			totalRows: 0,
			pageLimit: 10,
			merchantnameFlt: '',
			// totalRows:0,
			userid: '',
			// currentPage: 0,
			addProductFlag: false,
			viewProductFlag: false,
			editProductFlag: false,
			listProductData: [],
			listProductDataCsv: [],
			listProductCategory: [],
			listProductsubCategory: [],
			clientproductid: '',
			producttypedropdown:'',
			productid: '',
			productname: '',
			productcategory: '',
			productsubcategory: '',
			UOMerrors: '',
			brand: '',
			terms: false,
			expERR: '',
			dateErr: false,
			id: '',
			clientaction: '',
			isError: '',
			isUOMError: '',
			isuomtempError: '',
			ismaxtempError: '',
			UOMmaxerrors: '',
			ismintempError: '',
			isLoading: false,
			UOMtemperrors: '',
			UOMminerrors: '',
			ShowList: true,
			disableButton: false,
			editproductmodal: false,
			showpoform: false,
			listMerchantData: [],
			listProductcategoryData: [],
			listsubProductcategoryData: [],
			searchFlag:false,
			model: {
				productid: '',
				productname: '',
				productdescription: '',
				productcategory: '',
				brand: '',
			},
			// initialize form field
			defaultimage: 'http://tplstage.xbees.in/tplappv1/static/img/noimg.png',
			productDetailModal: false,
			bundleProductModal:false,
			bundleProductMappingDetails:[],
			productDetailData: {
				attribute1: "",
				brand: "",
				cgst: "",
				clientid: "",
				clientproductid: "",
				controltype: "",
				createdby: "",
				createddatetime: "",
				expirycontrolled: "",
				expirydate: "",
				hsncode: "",
				hsnrate: "",
				igst: "",
				isflammable: "0",
				isfragile: "0",
				ishazardous: "0",
				// ismrptracked: "1",
				isliquid: "0",
				lotcontrol: "0",
				nocontrol: "0",
				isserialcontrol: "0",
				istempsensitive: "0",
				lastmodifiedby: "",
				lastmodifieddate: "",
				maxtemp: "",
				merchantid: "",
				mfgcode: "",
				mintemp: "",
				mrp: "",
				primaryuom: "",
				productcategory: "",
				productdescription: "",
				productid: "",
				productimage: "",
				productname: "",
				productsubcategory: "",
				producttype: "",
				revisionno: "",
				secondaryuom: "",
				sgst: "",
				shelflifeduration: "",
				shelflifeuom: "",
				stickername: "",
				unitbreadth: "",
				unitdimensonuom: "",
				unitheight: "",
				unitlength: "",
				unitweight: "",
				unitweightuom: "",
				uomtemp: ""
			},
			listClientData: [],
			// pageCount: 0,
			// pageNo: 0,
			// pageLimit: 50,
			user_type: '',
			client: '',
			clientid: '',
			warehouseid: '',
			showSelectClient: false,
			ClientErr: '',
			tabIndex: 0,
			addproduct: {
				clientid: '',
				productid: '',
				merchantid: '',
				merchantname: '',
				maxtemp: '',
				isimgselected: 0,
				isimguploaded: 0,
				createdbyEmail: '',
				mintemp: '',
				productname: '',
				productcategory: '',
				productcategoryname: '',
				subcategoryname: '',
				productsubcategory: '',
				productdescription: '',
				categoryname: '',
				producttype: '',
				brand: '',
				clientproductid: '',
				productimage: '',
				hsncode: '',
				hsnrate: '',
				shelflifeduration: '',
				shelflifeuom: '',
				primaryuom: '',
				secondaryuom: '',
				unitweight: '',
				unitweightuom: '',
				fileupload: '',
				unitdimensonuom: '',
				unitlength: '',
				unitbreadth: '',
				unitheight: '',
				uomtemp: '',
				mfgcode: '',
				attribute1: '',
				lotcontrol: 0,
				nocontrol: 0,
				isserialcontrol: 0,
				ishazardous: 0,
				ismrptracked: 0,
				isfragile: 0,
				isflammable: 0,
				isliquid: 0,
				istempsensitive: 0,
				controltype: '',
				filetype: '',
				isactive: '',
				stickername: '',
				createddatetime: '',
				lastmodifieddate: '',
				lastmodifiedby: '',
				revisionno: '',
				inactivedate: '',
				inactiveby: '',
				expirycontrolled: 0,
				eancode: '',
				serializecontrol: 0,
				lotcontrol: '',
				strength: '',
				subbrand: '',
				color: '',
				size: '',
				velocitycode: '',
				mfgcontrolled: 0,
				unitprice: '',
				unitheightuom: '',
				unitlengthuom: '',
				unitbreadthuom: '',
				flipkartProductId: '',
				productTax: 0,
				amazonProductId: '',
				searchFlag:false,
				activemrp:'',
			},
			item:{},
			merchant:'',
			listMerchantData1:[],
			merchantList:[],
			merchantname:'',
			mid:'',
			showSelectMerchant:true,
			listReportDataforxls: [],
			csvFieldsForXls: {},
			reportname: '',
			show:'',
			limitExeed:'',
			download:true,
			ispuomError: '',
			 isUOMError: '',
			  isshelflifeError:'',
			  puomerrors :'',
			  uomyerrors:'',
			   shelflifeerrors:'',
			   only_outsideproducts:false,
				 productUploadLabelUrl:'',
				productUploadLabelUpload : '',
				 productUploadLabelUrlsave : '',
				 productUploadLabelUrl1 : '',
				 limitExeed:false,
				 recordLimit: 0,
				 activemrpflag:false,
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		},
		senddate: function(date) {
			return moment(date).format('YYYY-MM-DD');
		}
	},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;

		var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
		var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
		var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
		var innerdetail = JSON.parse(innerplaintext);
		this.getComponentPermission(innerdetail);

		this.reportname = this.$t('productLogReport.product')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.getRecordLimit()
		if (localStorage.getItem("selectedClient") !=='undefined')
		{
		this.getMerchantList()
		// this.getSubcategoryList()
		this.getProductCategory()
		}

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.getClientList();
				this.showSelectMerchant =true;

				break;
			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.getMerchantList();
				this.showSelectMerchant =true;
				this.getProductCategory();

				if(userdetail.merchantid){
				this.mid=userdetail.merchantid.toString()
				this.merchantnameFlt=this.mid
				this.showSelectMerchant =false;
				this.getProductData();

				}
				//this.getProductcategorylist();
				// this.getSubcategoryList();
				this.getActiveMrpFlag();
				break;
			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.getClientList();
				this.showSelectMerchant =true;
			default:
				//this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}

	},
	methods: {
		reset(){
			this.item={}
		},
		onSelect(item){

			this.item=item
			this.merchantnameFlt=item.value
		},
		getRecordLimit() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({

      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRecordLimit',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data) {
            this.recordLimit = result.data.data;


          }
        }, error => {
          console.error(error)
        })
    },
		onlyoutsideproducts(ev) {
			let checkbox11 = document.getElementById("only_outsideproducts")
			this.only_outsideproducts = checkbox11.checked
		},
		getProductCategory() {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.user_type == "client_user") {
				this.input = ({
					clientid: this.clientid
				})
			} else {
				this.input = ({
					clientid: this.client,
				});
			}

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductCategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listProductCategory = result.data.data;
				}, error => {
					console.error(error);
				});

		},
		getProductSubCategory() {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.listProductsubCategory = [];

			if (this.productcategory == "") {
				return false;
			} else {
				this.input = ({
					clientid: this.client,
					productcategory: this.productcategory
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getProductSubcategory',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						this.listProductsubCategory = result.data.data;
					}, error => {
						console.error(error);
					});
			}
		},
		//open new form(popup)
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = [] ) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
			  csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'
			//Fields
			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		getClientList() {
			if (window.localStorage.getItem("clientList") !== null) {
				var clientListEncrypt = window.localStorage.getItem('clientList');
				var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
				var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
				this.listClientData = JSON.parse(plaintextclient);
			} else {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.pageNo = this.pageCount = 0;
				this.input = ({
					warehouseid: this.warehouseid,
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						this.listClientData = result.data.data;
					}, error => {
						console.error(error);
					});
			}
		},
		getComponentPermission(innerdetail) {
			var component = 'product';
			var innerpermArr = {};
			for (var i = 0; i < innerdetail.length; i++) {
				if (innerdetail[i].controllerurl == component) {
					innerpermArr = innerdetail[i].permission;
					break;
				}
			}
			if (JSON.stringify(innerpermArr) == 'null') {
				//alert("wrong");
			} else {
				for (var i = 0; i < innerpermArr.length; i++) {
					if (innerpermArr[i].id == 'add') {
						this.addProductFlag = true;
					}
					if (innerpermArr[i].id == 'view') {
						this.viewProductFlag = true;
					}
					if (innerpermArr[i].id == 'edit') {
						this.editProductFlag = true;
					}
				}
			}

		},
		clientSelected() {
			this.clientid = this.client;
			this.pageNo = this.pageCount = 0;
			this.searchFlag=false;
			this.productcategory='';
			this.productsubcategory='';
			this.merchantnameFlt = '';
			this.clientproductid = '';
			this.productid = '';
			this.productname = '';
			this.listProductData = [];
			this.totalRows = 0;
			if (this.clientid) {
				//this.getProductData();
				//this.getProductData();
				this.getMerchantList();
				this.item={}
				//this.getProductcategorylist();
				this.getProductCategory();
				this.getActiveMrpFlag();
			}
			document.getElementById("productid").value = ""
            document.getElementById("productname").value = ""
            document.getElementById("clientproductid").value = ""
		},
		//to get productcategory name list


		async getProductRowData(data) {
			this.getMerchantList();
			this.getProductCategory();
			this.tabIndex = 0;
			this.showpoform = true;
			this.ShowList = false;

			if(data.shelflifeuom!=null){

			this.addproduct.shelflifeuom = data.shelflifeuom.trim();
			}

			this.addproduct.productid = data.productid;
			this.addproduct.clientproductid = data.clientproductid;
			this.addproduct.merchantname = data.merchantid;
			this.addproduct.flipkartProductId = data.flipkartid;
			this.addproduct.productTax = Number(data.producttax);
			this.addproduct.amazonProductId = data.amazonid;
			this.addproduct.productname = data.productname;
			this.addproduct.mrp = data.mrp;
			this.addproduct.productdescription = data.productdescription;
			// this.getProductcategorylist();
			this.addproduct.productcategoryname = data.productcategory;
			this.getSubcategoryList();
			this.addproduct.productsubcategory = data.productsubcategory;
			this.addproduct.producttype = data.producttype;
			this.addproduct.brand = data.brand;
			this.addproduct.filetype = data.productimage;
			this.addproduct.fileupload = data.productimage;
			this.addproduct.hsncode = data.hsncode;
			this.addproduct.hsnrate = data.hsnrate;
			this.addproduct.shelflifeduration = data.shelflifeduration;
			this.addproduct.primaryuom = data.primaryuom;
			this.addproduct.secondaryuom = data.secondaryuom;
			this.addproduct.unitweight = data.unitweight;
			this.addproduct.unitweightuom = data.unitweightuom;
			this.addproduct.unitdimensonuom = data.unitdimensonuom;
			this.addproduct.unitlength = data.unitlength;
			this.addproduct.unitbreadth = data.unitbreadth;
			this.addproduct.unitheight = data.unitheight;
			this.addproduct.uomtemp = data.uomtemp;
			this.addproduct.mintemp = data.mintemp;
			this.addproduct.maxtemp = data.maxtemp;
			this.addproduct.attribute1 = data.attribute1;
			this.addproduct.lotcontrol = Number(data.lotcontrol);
			this.addproduct.nocontrol = Number(data.nocontrol);
			this.addproduct.isserialcontrol = Number(data.isserialcontrol);
			this.addproduct.ishazardous = Number(data.ishazardous);
			this.addproduct.ismrptracked = Number(data.ismrptracked);
			this.addproduct.isfragile = Number(data.isfragile);
			this.addproduct.isflammable = Number(data.isflammable);
			this.addproduct.isliquid = Number(data.isliquid)
			this.addproduct.mfgcode = data.mfgcode;
			this.addproduct.istempsensitive = Number(data.istempsensitive);
			this.addproduct.isactive = data.isactive;
			this.addproduct.stickername = data.stickername;
			this.addproduct.createddatetime = data.createddatetime;
			this.addproduct.lastmodifieddate = data.lastmodifieddate;
			this.addproduct.lastmodifiedby = data.lastmodifiedby;
			this.addproduct.revisionno = data.revisionno;
			this.addproduct.inactivedate = data.inactivedate;
			this.addproduct.inactiveby = data.inactiveby;
			this.addproduct.expirycontrolled = Number(data.expirycontrolled);
			this.addproduct.eancode = data.eancode;
			this.addproduct.serializecontrol = Number(data.serializecontrol);
			this.addproduct.lotcontrol = Number(data.lotcontrol);
			this.addproduct.strength = data.strength;
			this.addproduct.subbrand = data.subbrand;
			this.addproduct.color = data.color;
			this.addproduct.size = data.size;
			this.addproduct.velocitycode = data.velocitycode;
			this.addproduct.mfgcontrolled = Number(data.mfgcontrolled);
			this.addproduct.unitprice = data.unitprice;
			this.addproduct.unitheightuom = data.unitheightuom;
			this.addproduct.unitlengthuom = data.unitlengthuom;
			this.addproduct.unitbreadthuom = data.unitbreadthuom;
			this.addproduct.activemrp = data.activemrp;
			this.ismintempError = '';
			this.ismaxtempError = '';
			this.isuomtempError = '';
			this.addproduct.shelflifeuom=	this.addproduct.shelflifeuom.charAt(0).toUpperCase()+this.addproduct.shelflifeuom.substring(1)
			if(data.productimage!= ''){
				let img = data.productimage;
				let exists  = img.includes('wms-stagetemp')
				if(exists){
					this.productUploadLabelUrl = await this.ShowImage(data.productimage);

				}else{
					this.productUploadLabelUrl = data.productimage;
				}
			}else {
				this.productUploadLabelUrl = '';
			}
			this.$validator.reset();
			this.errors.clear();
		},
		ShowImage(imagedata) {
			return new Promise((resolve, reject) => {

				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.pageno = 0;
				if (imagedata == null || imagedata == '' || imagedata == undefined) {
					//this.$alertify.error("Image Not Found");
					return false;
				}
				this.isLoading = true
				this.input = ({
					's3url': imagedata,
				});
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'viewImagebyurl',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				}).then((result) => {
					if (result.data.Status) {
						resolve(result.data.url)
						this.isLoading = false;

					} else {
						this.$alertify.error("Image Not Found");
						this.isLoading = false;
					}

				})
			})
		},
		// to get subcategory list
		getSubcategoryList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.listProductsubCategory = [];
			this.input = ({
				"clientid": this.clientid,
				"productcategory": this.addproduct.productcategoryname
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductSubcategory',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listProductsubCategory = result.data.data;
					this.editproductmodal = true;
				}, error => {
					console.error(error);
				})
		},

		getProductDataOnSearch() {
			this.currentPage = this.totalPage = 1;
			this.getProductData();
		},

		/////
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getAuditListForXLS(3)
			}
		},
		getAuditListForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				clientproductid: this.clientproductid.trim(),
				productid: this.productid.trim(),
				productname: this.productname.trim(),
				productcategory: this.productcategory.trim(),
				productsubcategory: this.productsubcategory.trim(),
				clientid: this.clientid,
				csvData: csvCheck,
				merchantid: this.merchantnameFlt,
				userid: this.userid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductListtime',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0 ) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls={};
							this.csvFieldsForXls[this.$t('common.clientProductId')] = 'clientproductid';
							this.csvFieldsForXls[this.$t('common.productId')] = 'productid';
							this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('common.productName')] = 'productname';
							this.csvFieldsForXls[this.$t('common.productDescription')] = 'productdescription';
							this.csvFieldsForXls[this.$t('common.productCategory')] = 'productcategory';
							this.csvFieldsForXls[this.$t('product.productSubCategory')] = 'productsubcategory';
							this.csvFieldsForXls[this.$t('common.productType')] = 'producttype';
							this.csvFieldsForXls[this.$t('common.productImage')] = 'productimage';
							this.csvFieldsForXls[this.$t('printProductDetails.gstRate')] = 'hsnrate';
							this.csvFieldsForXls[this.$t('editedjson.controlType')] = 'controltype';
							this.csvFieldsForXls[this.$t('printProductDetails.shelfLifeDuration')] = 'shelflifeduration';
							this.csvFieldsForXls[this.$t('editedjson.isActive')] = 'isactive';
							this.csvFieldsForXls[this.$t('printProductDetails.stickerName')] = 'stickername';
							this.csvFieldsForXls[this.$t('printProductDetails.primaryUom')] = 'primaryuom';
							this.csvFieldsForXls[this.$t('printProductDetails.secondaryUom')] = 'secondaryuom';
							this.csvFieldsForXls[this.$t('printProductDetails.unitWeight')] = 'unitweight';
							this.csvFieldsForXls[this.$t('printProductDetails.unitDimensonUom')] = 'unitdimensonuom';
							this.csvFieldsForXls[this.$t('printProductDetails.unitLength')] = 'unitlength';
							this.csvFieldsForXls[this.$t('printProductDetails.unitBreadth')] = 'unitbreadth';
							this.csvFieldsForXls[this.$t('printProductDetails.unitHeight')] = 'unitheight';
							this.csvFieldsForXls[this.$t('printProductDetails.minTemp')] = 'mintemp';
							this.csvFieldsForXls[this.$t('printProductDetails.maxTemp')] = 'maxtemp';
							this.csvFieldsForXls[this.$t('printProductDetails.uomTemp')] = 'uomtemp';
							this.csvFieldsForXls[this.$t('common.createdDateTime')] = 'createddatetime';
							this.csvFieldsForXls[this.$t('common.createdBy')] = 'createdby';
							this.csvFieldsForXls[this.$t('common.lastModifiedDate')] = 'lastmodifieddate';
							this.csvFieldsForXls[this.$t('common.lastModifiedBy')] = 'lastmodifiedby';
							this.csvFieldsForXls[this.$t('editedjson.revisionNo')] = 'revisionno';
							this.csvFieldsForXls[this.$t('editedjson.inActiveDate')] = 'inactivedate';
							this.csvFieldsForXls[this.$t('editedjson.inActiveBy')] = 'inactiveby';
							this.csvFieldsForXls[this.$t('common.productId')] = 'productid';
							this.csvFieldsForXls[this.$t('common.expiryDate')] = 'expirydate';
							this.csvFieldsForXls[this.$t('printProductDetails.expiryControlled')] = 'expirycontrolled';
							this.csvFieldsForXls[this.$t('unicommerce.unicommerceProduct.ShelfLifeUOM')] = 'shelflifeuom';
							this.csvFieldsForXls[this.$t('printProductDetails.isTempSensitive')] = 'istempsensitive';
							this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('editedjson.serializeControl')] = 'serializecontrol';
							this.csvFieldsForXls[this.$t('printProductDetails.lotControl')] = 'lotcontrol';
							this.csvFieldsForXls[this.$t('printProductDetails.noControl')] = 'nocontrol';
							this.csvFieldsForXls[this.$t('common.mrp')] = 'mrp';
							this.csvFieldsForXls[this.$t('common.cgst')] = 'cgst';
							this.csvFieldsForXls[this.$t('common.sgst')] = 'sgst';
							this.csvFieldsForXls[this.$t('common.igst')] = 'igst';
							this.csvFieldsForXls[this.$t('printProductDetails.isLotcontrol')] = 'islotcontrol';
							this.csvFieldsForXls[this.$t('printProductDetails.noControl')] = 'nocontrol';
							this.csvFieldsForXls[this.$t('printProductDetails.isSerialcontrol')] = 'isserialcontrol';
							this.csvFieldsForXls[this.$t('printProductDetails.isExpirycontrol')] = 'isexpirycontrol';
							this.csvFieldsForXls[this.$t('printProductDetails.isHazardous')] = 'ishazardous';
							this.csvFieldsForXls[this.$t('printProductDetails.isFragile')] = 'isfragile';
							this.csvFieldsForXls[this.$t('printProductDetails.isflammable')] = 'isflammable';
							this.csvFieldsForXls[this.$t('printProductDetails.isLiquid')] = 'isliquid';
							this.csvFieldsForXls[this.$t('printProductDetails.mfgCode')] = 'mfgcode';
							this.csvFieldsForXls[this.$t('printProductDetails.strength')] = 'strength';
							this.csvFieldsForXls[this.$t('printProductDetails.attribute1')] = 'attribute1';
							this.csvFieldsForXls[this.$t('printProductDetails.subBrand')] = 'subbrand';
							this.csvFieldsForXls[this.$t('common.color')] = 'color';
							this.csvFieldsForXls[this.$t('common.size')] = 'size';
							this.csvFieldsForXls[this.$t('printProductDetails.velocityCode')] = 'velocitycode';
							this.csvFieldsForXls[this.$t('editedjson.mfgControlled')] = 'mfgcontrolled';
							this.csvFieldsForXls[this.$t('printProductDetails.unitPrice')] = 'unitprice';
							this.csvFieldsForXls[this.$t('common.brand')] = 'brand';
							this.csvFieldsForXls[this.$t('printProductDetails.hsnCode')] = 'hsncode';
							this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.PickedDate')] = 'pickeddate';
							this.csvFieldsForXls[this.$t('productPlaceHolder.productTaxPlaceHolder')] = 'producttax';
							this.csvFieldsForXls[this.$t('common.merchantName')] = 'merchantname';
							this.csvFieldsForXls[this.$t('printProductDetails.isMRPTracked')] = 'ismrptracked';

							this.listReportDataforxls = result.data.data;

								for (var j = 0; j < this.listReportDataforxls.length; j++) {
									for (var i = 0; i < this.listMerchantData.length; i++) {
										if (this.listMerchantData[i].merchantid == this.listReportDataforxls[j].merchantid) {
											this.listReportDataforxls[j].merchantname = this.listMerchantData[i].merchantname
										}
									}
								}
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

				}, error => {
					console.error(error);
				})
		},



		/////
		getProductData(csvCheck = 0) {
			this.searchFlag=true;
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.ClientErr = this.$t('srReport.clientError');
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.pageCount = 0;
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;

			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.currentPage=1;
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				clientproductid: this.clientproductid.trim(),
				productid: this.productid.trim(),
				productname: this.productname.trim(),
				productcategory: this.productcategory.trim(),
				productsubcategory: this.productsubcategory.trim(),
				clientid: this.clientid,
				csvData: csvCheck,
				merchantid: this.merchantnameFlt,
				userid: this.userid,
				only_outsideproducts:this.only_outsideproducts,
				producttype:this.producttypedropdown.trim()
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductListtime',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.listProductDataCsv = [];
							this.csvFields = {
								'clientproductid': this.$t('common.clientProductId'),
								'productid': this.$t('common.productId'),
								'eancode': this.$t('common.eanCode'),
								'productname': this.$t('common.productName'),
								'productdescription': this.$t('common.productDescription'),
								'productcategory': this.$t('common.productCategory'),
								'productsubcategory': this.$t('product.productSubCategory'),
								'producttype': this.$t('common.productType'),
								'productimage': this.$t('common.productImage'),
								'hsnrate': this.$t('printProductDetails.gstRate'),
								'controltype': this.$t('editedjson.controlType'),
								'shelflifeduration': this.$t('printProductDetails.shelfLifeDuration'),
								'isactive': this.$t('editedjson.isActive'),
								'stickername': this.$t('printProductDetails.stickerName'),
								'primaryuom': this.$t('printProductDetails.primaryUom'),
								'secondaryuom': this.$t('printProductDetails.secondaryUom'),
								'unitweight': this.$t('printProductDetails.unitWeight'),
								'unitweightuom': this.$t('unicommerce.unicommerceProduct.unitWeightUOM'),
								'unitdimensonuom': this.$t('printProductDetails.unitDimensonUom'),
								'unitlength': this.$t('printProductDetails.unitLength'),
								'unitbreadth': this.$t('printProductDetails.unitBreadth'),
								'unitheight': this.$t('printProductDetails.unitHeight'),
								'mintemp': this.$t('printProductDetails.minTemp'),
								'maxtemp': this.$t('printProductDetails.maxTemp'),
								'uomtemp': this.$t('printProductDetails.uomTemp'),
								'createddatetime': this.$t('common.createdDateTime'),
								'createdby': this.$t('common.createdBy'),
								'lastmodifieddate': this.$t('common.lastModifiedDate'),
								'lastmodifiedby': this.$t('common.lastModifiedBy'),
								'revisionno': this.$t('editedjson.revisionNo'),
								'inactivedate': this.$t('editedjson.inActiveDate'),
								'inactiveby': this.$t('editedjson.inActiveBy'),
								'expirydate': this.$t('common.expiryDate'),
								'expirycontrolled': this.$t('printProductDetails.expiryControlled'),
								'shelflifeuom': this.$t('unicommerce.unicommerceProduct.FlipkartProductId'),
								'istempsensitive': this.$t('printProductDetails.isTempSensitive'),
								'serializecontrol': this.$t('editedjson.serializeControl'),
								'lotcontrol': this.$t('printProductDetails.lotControl'),
								'nocontrol': this.$t('printProductDetails.noControl'),
								'mrp': this.$t('common.mrp'),
								'cgst': this.$t('common.cgst'),
								'sgst': this.$t('common.sgst'),
								'igst': this.$t('common.igst'),
								'islotcontrol': this.$t('printProductDetails.isLotcontrol'),
								'nocontrol': this.$t('printProductDetails.noControl'),
								'isserialcontrol': this.$t('printProductDetails.isSerialcontrol'),
								'isexpirycontrol': this.$t('printProductDetails.isExpirycontrol'),
								'ishazardous': this.$t('printProductDetails.isHazardous'),
								'isfragile': this.$t('printProductDetails.isFragile'),
								'isflammable': this.$t('printProductDetails.isflammable'),
								'isliquid': this.$t('printProductDetails.isLiquid'),
								'mfgcode': this.$t('printProductDetails.mfgCode'),
								'strength': this.$t('printProductDetails.strength'),
								'attribute1': this.$t('printProductDetails.attribute1'),
								'subbrand': this.$t('printProductDetails.subBrand'),
								'color': this.$t('common.color'),
								'size': this.$t('common.size'),
								'velocitycode': this.$t('printProductDetails.velocityCode'),
								'mfgcontrolled': this.$t('editedjson.mfgControlled'),
								'unitprice': this.$t('printProductDetails.unitPrice'),
								'unitheightuom': this.$t('common.unitHeightUOM'),
								'unitlengthuom': this.$t('common.unitLengthUOM'),
								'brand': this.$t('common.brand'),
								'hsncode': this.$t('printProductDetails.hsnCode'),
								'unitbreadthuom': this.$t('common.unitBreadthUOM'),
								'flipkartid': this.$t('unicommerce.productStock.flipkartid'),
								'amazonid': this.$t('unicommerce.unicommerceProduct.isamazon'),
							   'producttax': this.$t('productPlaceHolder.productTaxPlaceHolder'),
								'merchantname': this.$t('common.merchantName'),
								'ismrptracked': this.$t('printProductDetails.isMRPTracked'),
								'integrationproductid': this.$t('printProductDetails.integrationProductid'),
							};
							var dateFilter = ['cancelleddate', 'pickeddate'];
							var skipFilter = ['merchantid','isoutsideproduct','activemrp','iscrossdock'];
							this.listProductDataCsv = result.data.data;
							for (var j = 0; j < this.listProductDataCsv.length; j++) {
								this.listProductDataCsv[j].merchantname = null;
								for (var i = 0; i < this.listMerchantData.length; i++) {
									if (this.listProductDataCsv[j].merchantid == this.listMerchantData[i].merchantid) {
										this.listProductDataCsv[j].merchantname = this.listMerchantData[i].merchantname
									}

								}
							}
							this.jsonToCSV(this.$t('productLogReport.product'), this.listProductDataCsv, this.csvFields, dateFilter, skipFilter,dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listProductData = result.data.rows;
						this.listMerchantData=this.listMerchantData

						if (result.data.errorCode == -1) {
							this.listProductData = [];
							this.listMerchantData=[];
							this.resultCount = 0;
							this.totalRows = 0;
							this.$alertify.error(result.data.msg);
						}

						for (var j = 0; j < this.listProductData.length; j++) {
							for (var i = 0; i < this.listMerchantData.length; i++) {
								if (this.listMerchantData[i].merchantid == this.listProductData[j].merchantid) {
									this.listProductData[j].merchantname = this.listMerchantData[i].merchantname
								}
							}
						}

							this.totalRows = result.data.count;
							this.resultCount = result.data.count;
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}

					// this.listProductData = result.data.rows;
					// this.ShowList = true;
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},

		printproduct(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var productid = data.productid;
			var mrp = data.mrp;
			this.input = ({
				productid: productid,
				mrp: mrp,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'printproduct',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg);
					}
				}, error => {
					console.error(error);
				})
		},

		async loadProduct(data) {
			this.productDetailModal = true;
			if(data.productimage != ''){
				let img = data.productimage;
				let exists1  = img.includes('wms-stagetemp')
				if(exists1){
					this.productUploadLabelUrl1 = await this.ShowImage(data.productimage);
				}else{
					this.productUploadLabelUrl1 = data.productimage;
				}
			}else {
				this.productUploadLabelUrl1 = '';
			}
			this.productDetailData = data;

		},

		async getBundleProductData(data){
            var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input={
				clientid:window.localStorage.getItem("selectedClient"),
				productid:data.productid
			}
			await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getBundleChildProducts',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(result => {
				if (result.data.data.ErrorCode == 0) {
					this.bundleProductMappingDetails=result.data.data.data;
				}else{
					this.bundleProductMappingDetails=[];
				}
			}, error => {
				console.error(error);
			})
		},

		async loadBundleProduct(data){
            this.bundleProductModal=true;
			this.getBundleProductData(data)
		},

		closeBundleProductModal() {
			this.bundleProductModal = false;
		},

		closeProductModal() {
			this.productDetailModal = false;
		},

		imageLoadError() {
			this.productDetailData.productimage = this.defaultimage;
		},
		//changes for edit product
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.pageCount = 1;
				} else {
					this.pageCount = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.pageCount = 0;
			}
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                        var merchantlistArray=[];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
					   result.data.forEach(function(item){
						   merchantlistArray[item.merchantid]=item.merchantname;

					   })
					   this.merchantList=merchantlistArray;
					   this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })

					}
				}, error => {
					console.error(error);
				})
		},

		Checkshelfduration() {
			if (this.addproduct.shelflifeduration == null) {
				this.isUOMError = '1';
				this.uomyerrors = ' Shelf Life Duration is required';
			} else {
				this.isUOMError = '0';
				this.uomyerrors = '';
			}
		},

		lifeuom() {
			if (this.addproduct.shelflifeduration != '') {

				if(this.addproduct.shelflifeduration>0){
				this.isUOMError = '';
				this.uomyerrors = '';
				this.isshelflifeError = '';
				this.shelflifeerrors = '';}
				else{
					this.isshelflifeError = '1';
					this.shelflifeerrors = 'Shelf Life Duration should be greater than 0';

				}
			}
			if (this.addproduct.primaryuom != '') {
				this.puomerrors = '';
				this.ispuomError = '';
			}
		},

		temsensitiveChange() {
			if (this.addproduct.istempsensitive == 0) {
				this.addproduct.mintemp = '';
				this.addproduct.maxtemp = '';
				this.addproduct.uomtemp = '';
				this.ismintempError = '0';
				this.ismaxtempError = '0';
				this.isuomtempError = '0';
				this.UOMtemperrors = '';
				this.UOMmaxerrors = '';
				this.UOMminerrors = ''
				this.addproduct.istempsensitive = 0
			}
		},

		linkClass(idx) {
			if (this.tabIndex === idx) {
				return ['bg-primary', 'text-light']
			} else {
				return ['bg-light', 'text-info']
			}
		},
		//Call page number from pagination
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getProductData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getProductData()
		},

		validateTab() {
			this.$validator.validateAll('tab1').then((result) => {
				if (result) {
					this.tabIndex = 1;
				} else {
					this.tabIndex = 0;
					return false;
				}
			}).catch(() => {
				this.tabIndex = 0
				console.log('errors exist', this.errors)
			});
		},
		validateTab2() {
			this.$validator.validateAll('tab2').then((result) => {
				if (!result) {
					this.tabIndex = 1;
					return false;
				}
			}).catch(() => {
				this.tabIndex = 1;
				console.log('errors exist', this.errors)
			});
		},

		Checktemp() {
			if (Number(this.addproduct.maxtemp) < Number(this.addproduct.mintemp)) {
				this.isError = '1';
				this.Qtyerrors = 'Max Temp should be greater than Min  Temp';
				this.ismintempError = '';
				this.ismaxtempError = '';
			} else {
				this.ismintempError = '';
				this.ismaxtempError = '';
				this.isError = '';
				this.Qtyerrors = '';
			}
		},

		editProduct() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.addproduct.producttype = this.addproduct.producttype == null ? "" : this.addproduct.producttype

			if (this.clientid == '') {
				this.ClientErr = "Client is required";
				return false;
			}
			if (this.addproduct.istempsensitive == 1) {
				if (this.addproduct.uomtemp == '' || this.addproduct.uomtemp == null && this.addproduct.maxtemp == '' || this.addproduct.maxtemp == null && this.addproduct.mintemp == '' || this.addproduct.mintemp == null) {
					this.ismintempError = '1';
					this.ismaxtempError = '1';
					this.isuomtempError = '1';
					this.UOMtemperrors = 'UOM Temp field is required';
					this.UOMmaxerrors = 'Max Temp fields is required';
					this.UOMminerrors = 'Min Temp fields is required'
					return false;
				} else {
					this.ismintempError = '';
					this.ismaxtempError = '';
					this.isuomtempError = '';
				}
			}
///ispuomError isUOMError isshelflifeError
			if (this.isimgselected == 1 && this.isimguploaded == 0) {
				alert('please wait image is uploading');
				return false;
			}
			if (this.addproduct.fileupload != null) {
				this.addUrl = this.addproduct.fileupload;
			}
			if (this.productUploadLabelUrlsave) {
             this.addUrl  = this.productUploadLabelUrlsave
			}
			// if (this.addproduct.nocontrol == 0) {
			// 	this.addproduct.lotcontrol = 0
			// 	this.addproduct.expirycontrolled = 0
			// 	this.addproduct.shelflifeduration = ''
			// 	this.addproduct.primaryuom =''
			// 	this.addproduct.shelflifeuom =''
			// }
			if(this.addproduct.expirycontrolled == 0){
				this.addproduct.shelflifeduration = ''
				this.addproduct.primaryuom =''
				this.addproduct.shelflifeuom =''

			}
			if (this.addproduct.nocontrol == 1) {
				if (this.addproduct.lotcontrol == 0 && this.addproduct.expirycontrolled == 0) {
					this.$alertify.error("Please select either lotcontrol or expirycontrolled");
					return false;
				}
			}

			if (this.addproduct.nocontrol == 1 && this.addproduct.expirycontrolled == 1 ) {


				if (this.addproduct.shelflifeduration == '' || this.addproduct.shelflifeduration == null) {
					this.isshelflifeError = '1';
					this.shelflifeerrors = 'Shelf Life Duration field is required'
					return false;
				}
				// else if (this.addproduct.shelflifeuom == '' || this.addproduct.shelflifeuom == null) {
				// 	this.isUOMError = '1';
				// 	this.uomyerrors = 'Shelf life UOM field is required';
				// 	return false;
				// }

				// else if (this.addproduct.primaryuom == '' || this.addproduct.primaryuom == null) {
				// 	this.ispuomError = '1';
				// 	this.puomerrors  = 'Primary UOM  field is required';
				// 	return false;

				// }
				else {
					this.ispuomError = '';
					this.isUOMError = '';
					this.isshelflifeError = '';
				}
			}

/////////////////////
			this.isLoading = true;
			this.input = ({
				'productid': Number(this.addproduct.productid),
				'clientid': Number(localStorage.getItem("selectedClient")),
				'clientproductid': this.addproduct.clientproductid,
				'merchantid':Number( this.addproduct.merchantname ? this.addproduct.merchantname : ''),
				'productname': this.addproduct.productname,
				'mrp': Number(this.addproduct.mrp),
				'productdescription': this.addproduct.productdescription ? this.addproduct.productdescription : '',
				'productcategory': this.addproduct.productcategoryname,
				'productsubcategory': this.addproduct.productsubcategory,
				'producttype': this.addproduct.producttype,
				'brand': this.addproduct.brand,
				'productimage': this.addUrl,
				'hsncode': this.addproduct.hsncode,
				'hsnrate': Number(this.addproduct.hsnrate),
				'shelflifeduration': Number(this.addproduct.shelflifeduration),
				'shelflifeuom': this.addproduct.shelflifeduration != null ? 'day' : '',
				'primaryuom': this.addproduct.primaryuom != null ? this.addproduct.primaryuom : '',
				'secondaryuom': this.addproduct.secondaryuom != null ? this.addproduct.secondaryuom : '',
				'unitweight': Number(this.addproduct.unitweight),
				'unitweightuom': this.addproduct.unitweight != null ? 'gm' : '',
				'unitdimensonuom': this.addproduct.unitdimensonuom != null ? this.addproduct.unitdimensonuom : '',
				'unitlength': Number(this.addproduct.unitlength),
				'unitbreadth': Number(this.addproduct.unitbreadth),
				'unitheight': Number(this.addproduct.unitheight),
				'uomtemp': this.addproduct.uomtemp != null ? this.addproduct.uomtemp : '',
				'mintemp': Number(this.addproduct.mintemp),
				'maxtemp': Number(this.addproduct.maxtemp),
				'attribute1': this.addproduct.attribute1 != null ? this.addproduct.attribute1 : '',
				'lotcontrol': Number(this.addproduct.lotcontrol),
				'nocontrol': Number(this.addproduct.lotcontrol) == 1 || Number(this.addproduct.expirycontrolled) == 1 ? 1:0,
				'isserialcontrol': Number(this.addproduct.isserialcontrol),
				'ishazardous': Number(this.addproduct.ishazardous),
				'ismrptracked': Number(this.addproduct.ismrptracked),
				'isfragile': Number(this.addproduct.isfragile),
				'isflammable': Number(this.addproduct.isflammable),
				'isliquid': Number(this.addproduct.isliquid),
				'mfgcode': this.addproduct.mfgcode,
				'istempsensitive': this.addproduct.istempsensitive,
				'stickername': this.addproduct.stickername != null ? this.addproduct.stickername : '',
				'expirycontrolled': Number(this.addproduct.expirycontrolled),
				'eancode': this.addproduct.eancode != '' ? this.addproduct.eancode :this.addproduct.clientproductid,
				'serializecontrol': Number(this.addproduct.serializecontrol),
				'subbrand': this.addproduct.subbrand,
				'color': this.addproduct.color,
				'size': this.addproduct.size,
				'velocitycode': this.addproduct.velocitycode != null ? this.addproduct.velocitycode : '',
				'mfgcontrolled': Number(this.addproduct.mfgcontrolled),
				'unitprice': Number(this.addproduct.unitprice),
				'unitheightuom': this.addproduct.unitheight != null ? 'cm' : '',
				'unitlengthuom': this.addproduct.unitlength != null ? 'cm' : '',
				'unitbreadthuom': this.addproduct.unitbreadth != null ? 'cm' : '',
				'lastmodifieddate': new Date(),
				'lastmodifiedby': this.createdbyEmail,
				//'flipkartid': this.addproduct.flipkartProductId,
				'producttax': Number(this.addproduct.productTax),
				//'amazonid': this.addproduct.amazonProductId,
				'activemrp': Number(this.addproduct.activemrp)
			})
			//console.log(this.addproduct.flipkartProductId, " this.addproduct.flipkartProductId=======================================");
			//console.log(this.addproduct.amazonProductId, "this.addproduct.amazonProductId=======================================");

			//console.log(Number(this.addproduct.productTax), " Number(this.addproduct.productTax)=======================================");
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'UpdateProduct',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					this.isLoading = false;
					if (response.data.status == true) {
					  this.$alertify.success(response.data.msg );
					} else {
					  this.$alertify.error(response.data.msg );
					}
					this.iserror = false;
					this.getProductData();
					this.resetform();

				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		resetform() {
			this.ShowList = true;
			this.showpoform = false;
		},

		//end changes for edit product
		createGoogleLink(imageLink, id) {
			var preURL = 'https://drive.google.com/uc?export=view&id=';
			var validUrl = '';
			var tempUrl = imageLink.split('?id=');
			if (tempUrl.length == 1) {
				var tempURL = imageLink.split('https://drive.google.com/file/d/');
				var tempURL1 = tempURL[1].split('/view');
				var validUrl = preURL + tempURL1[0];
				//this.productimage = validUrl;
				$("#" + id).attr("src", validUrl);
			} else {
				validUrl = preURL + tempUrl[1];
				$("#" + id).attr("src", validUrl);
			}
		},

		resetFlt() {
			this.merchantnameFlt = '';
			this.totalRows = 0;
			this.productid = '';
			// this.clientid = '';
			this.merchant = '';
			this.merchantname = '';
			this.clientproductid = '';
			this.producttypedropdown='';
			this.productname = '';
			//this.client = "";
			this.listProductData = [];
			this.listProductDataCsv = [];
			this.totalPage = 0;
			//this.currentPage = 1,
			this.only_outsideproducts=false;
			this.$validator.reset();
			this.item={}
			this.productsubcategory = '';
			this.productcategory = '';
			this.searchFlag=false;
			// if (this.user_type == 'warehouse_user'){
			// 	this.client = '';
			// 	// this.listProductCategory = [];
			// 	// this.listProductsubCategory = [];
			// }
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.clientid = '';

			// 	this.warehouse = '';
			// 	// this.listProductCategory = [];
			// 	// this.listProductsubCategory = [];
			// }
			// if (this.clientid && this.user_type == 'client_user') {
			// 	this.getProductData();
			// } else {
			// 	this.clientid = '';
			// }
		},
		async validatevalues() {
			try {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.getProductData(2);
					} else {
						console.log("not valid")
					}
				})
			}
			catch (err) {
				this.isLoading = false;
				this.$alert(err, "", "error");
				console.log(err);
			}
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model);
			}).catch(() => {
				console.log('errors exist', this.errors);
			});
		},


		// function using for file uploading
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
			let imageTypes = ['image/jpeg', 'image/png']
			let imageFormat = this.file.type
			let checkFormat = imageTypes.includes(imageFormat)
			if (!checkFormat) {
				this.file = null
				document.getElementById('file').value = null
				this.$alert("Invalid image format")
			}
		},
		async saveImage(imagetype, inputtype) {
			try {
				 if (!this.file && inputtype == 'file') {
					this.$alert("Select image")
					return false
				}
				if (inputtype == 'file') {
					console.log("=============553=========");
					var imgpath = document.getElementById('Image');
					if (!imgpath.value == "") {
						var img = imgpath.files[0].size;
						var imgsize = img / 1024;
						if (imgsize > 4000) {
							this.$alert("Image size cannot be greater than 4mb")
							document.getElementById('file').value = null
							this.file=null
							return false;
						}
					}
				}

				let imageString = ""
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');

					let reader = new FileReader()
					reader.readAsDataURL(this.file)
					imageString = await new Promise((resolve, reject) => {
						reader.onload = function() {
							this.base64String = reader.result.replace("", "")
							resolve(this.base64String)
						}
					})

				let inputpayload = {
					imagestring: imageString,
				}
				this.isLoading = true

		let Result = await common_helper.getRestApiResponse('POST', 'addimageforOutsideProduct', inputpayload, this.$alertify)
			if (Result && !Result.errorDATA) {
					if (Result.data.status == true) {
					//	this.file = null
						if (imagetype == 'Productimage') {
							this.productUploadLabelUpload = true
							this.productUploadLabelUrl = Result.data.presignurl
							this.productUploadLabelUrlsave = Result.data.dburl
						}
						//alert(this.productUploadLabelUrl)

						this.$alertify.success(Result.data.data)
						this.isLoading = false

					} else {
						this.$alert(Result.data.msg)
						return false
					}
				}

			} catch (err) {
				console.log(err)
			}
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		submitFile() {
			if (this.clientid == '') {
				this.ClientErr = "Client is required";
				return false;
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var formData = new FormData();
			formData.append('file', this.file);
			formData.append('clientid', this.clientid);
			axios.post(apiUrl.api_url + 'upload_file2',
					formData, {
						headers: {
							'Authorization': 'Bearer ' + myStr,
							'Content-Type': 'multipart/form-data'
						},
					})
				.then((response) => {
					this.imagerelativepath = response.data.path;
					this.filename = response.data.filename
					this.isimguploaded = 1;
					if (response.status == true) {
						this.error_seen = false;
						this.success_seen = true;
						this.error_message = '';
						this.success_message = response.data.numrows + " items added successfully";
					} else {
						this.error_seen = true;
						this.success_seen = false;
						this.error_message = response.message;
						this.success_message = '';
					}
				})
				.catch(function() {
					;
					console.log('FAILURE!!');
				});
		},
		myevent(productUploadLabelUrl) {
			if (productUploadLabelUrl != '') {
				this.isLoading = false
			}
		},
		//end of function for file uploading
	}
}



// WEBPACK FOOTER //
// ./src/views/components/product/product.component.js